const SEARCH_HISTORY = 'searchHistory'
const TOKEN = 'token'
const USERINFO = 'userInfo'
const REFRESH_TOKEN = 'refresh_token'
const ROLES = 'roles'
const PERMISSIONS = 'permissions'
const TENANTCODE = 'tenantCode'
const SYS_CONFIG = 'sys_config'

const EXAM = 'exam'
const EXAM_RECORD = 'examRecord'
const SUBJECT = 'subject'
const INCORRECT_RECORD = 'incorrectRecord'
const CARDS = 'cards'

const PRACTICE = 'practice'
const PRACTICE_RECORD = 'practiceRecord'
const PRACTICE_SUBJECT = 'practiceSubject'

const STATE_INFO = 'stateInfo'

export {
  SEARCH_HISTORY,
  TOKEN,
  USERINFO,
  ROLES,
  REFRESH_TOKEN,
  PERMISSIONS,
  TENANTCODE,
  SYS_CONFIG,
  EXAM,
  EXAM_RECORD,
  SUBJECT,
  INCORRECT_RECORD,
  CARDS,
  PRACTICE,
  PRACTICE_RECORD,
  PRACTICE_SUBJECT,
  STATE_INFO
}



// WEBPACK FOOTER //
// ./src/utils/storeMap.js